var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"loading"},[_c('section',{staticClass:"lds-roller"},[_c('section'),_c('section'),_c('section'),_c('section'),_c('section'),_c('section'),_c('section'),_c('section')])])
}]

export { render, staticRenderFns }